import { loadUIConfig } from "@digatex/digatex-ui-lib"

export const UI_CONFIG = loadUIConfig()
export const API_URL = process.env.REACT_APP_API_URL
